import { FormattedMessage } from "react-intl";

export const CALERNDAR_TYPES = {
  PUBLICATIONS: 1,
  EVENTS: 2,
  INTERNATIONAL_DAY: 3,
};
export const CalendarEventType = [
  { value: CALERNDAR_TYPES.EVENTS, label: <FormattedMessage id="event" /> },
  {
    value: CALERNDAR_TYPES.INTERNATIONAL_DAY,
    label: <FormattedMessage id="internationalDay" />,
  },
];
